<template>
  <v-dialog
    :value="value"
    persistent
    max-width="460"
    @input="$emit('input', $event)"
  >
    <v-card class="seat-paywall">
      <div class="seat-paywall__hero text-center pt-6 pb-1">
        <v-icon size="56" color="primary">mdi-account-multiple-plus</v-icon>
        <h3 class="seat-paywall__title mt-3">{{ $t('seat_paywall.title') }}</h3>
      </div>
      <v-card-text class="text-center pb-2">
        <p class="seat-paywall__lead">{{ $t('seat_paywall.lead') }}</p>

        <div class="seat-paywall__seats my-3">
          <span class="error--text font-weight-bold">{{ info ? info.count : '' }}</span>
          <span class="mx-1 grey--text">/</span>
          <span class="font-weight-bold">{{ info ? info.limit : '' }}</span>
          <div class="text-caption grey--text">{{ $t('seat_paywall.seats_used') }}</div>
        </div>

        <!-- FT-077: степпер количества докупаемых мест -->
        <div class="d-flex align-center justify-center mt-2">
          <v-btn icon small :disabled="busy || qty <= 1" @click="qty = Math.max(1, qty - 1)">
            <v-icon>mdi-minus-circle-outline</v-icon>
          </v-btn>
          <div class="seat-paywall__qty mx-4">{{ qty }}</div>
          <v-btn icon small :disabled="busy" @click="qty = qty + 1">
            <v-icon>mdi-plus-circle-outline</v-icon>
          </v-btn>
        </div>
        <div class="text-caption grey--text">{{ $t('seat_paywall.seats_to_add') }}</div>

        <v-chip v-if="totalLabel" label color="primary" outlined class="mt-3">
          {{ totalLabel }}
        </v-chip>

        <p class="text-caption grey--text mt-3 mb-0">{{ $t('seat_paywall.note') }}</p>
      </v-card-text>

      <v-card-actions class="d-flex flex-column px-4 pb-4">
        <v-btn block color="primary" :loading="busy" @click="$emit('buy', qty)">
          <v-icon left>mdi-plus-circle</v-icon>
          {{ $t('seat_paywall.buy') }}
        </v-btn>
        <v-btn block text class="mt-2" :disabled="busy" @click="$emit('to-tariff')">
          {{ $t('seat_paywall.change_plan') }}
        </v-btn>
        <v-btn block small text class="mt-1" :disabled="busy" @click="$emit('input', false)">
          {{ $t('seat_paywall.later') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// FT-077: маркетинговый seat-пейвол. Управляется родителем через mixins/seatPaywall.js
// (v-model=show, :info=payload 422, :busy). Эмитит buy(qty) / to-tariff / input(false=later).
// Степпер qty — сколько доп.мест докупить за раз (бэкенд инкрементит extra_user на qty).
export default {
  name: "SeatLimitDialog",
  props: {
    value: { type: Boolean, default: false },
    info: { type: Object, default: null },
    busy: { type: Boolean, default: false },
  },
  data: () => ({ qty: 1 }),
  watch: {
    // сброс количества при каждом открытии
    value(open) {
      if (open) this.qty = 1;
    },
  },
  computed: {
    unitPrice() {
      if (!this.info || this.info.extra_user_price == null) return null;
      return Number(this.info.extra_user_price);
    },
    // Итог: qty × цена/место (+ подпись валюты и /мес).
    totalLabel() {
      if (this.unitPrice == null) return null;
      const cur = (this.info && this.info.currency) || "";
      const total = this.unitPrice * this.qty;
      const per = this.$t("seat_paywall.per_month");
      const breakdown = this.qty > 1 ? ` (${this.qty} × ${this.unitPrice} ${cur})`.trim() : "";
      return `${total} ${cur}${per ? "/" + per : ""}${breakdown}`.trim();
    },
  },
};
</script>

<style scoped>
.seat-paywall__title {
  font-size: 1.25rem;
  font-weight: 700;
}
.seat-paywall__lead {
  font-size: 0.95rem;
}
.seat-paywall__seats {
  font-size: 1.6rem;
  line-height: 1.2;
}
.seat-paywall__qty {
  font-size: 1.5rem;
  font-weight: 700;
  min-width: 32px;
}
</style>
